import { JSConn } from "@/utilities/js-conn";
import { newSortOrderValue } from "@/utilities/sortOrder";

export default {
  name: "templateWorkOrderTasks",
  data() {
    return {};
  },
  computed: {
    templateWorkOrderTasks: function() {
      return this.$store.getters.templateWorkOrderTasks;
    },
  },
  methods: {
    moveTaskUp(task) {
      const newSortOrder = newSortOrderValue(
        task,
        "up",
        this.templateWorkOrderTasks,
      );
      if (newSortOrder.noChangeNeeded) {
        return;
      } else {
        const jsConn = new JSConn();
        jsConn.formParams = {
          id: task.id,
          sort_order: newSortOrder.newSortOrder,
        };

        this.$store.dispatch("updateTemplateWorkOrderTask", jsConn).then(() => {
          this.$emit("templateTasksChanged");
        });
      }
    },
    moveTaskDown(task) {
      const newSortOrder = newSortOrderValue(
        task,
        "down",
        this.templateWorkOrderTasks,
      );
      if (newSortOrder.noChangeNeeded) {
        return;
      } else {
        const jsConn = new JSConn();
        jsConn.formParams = {
          id: task.id,
          sort_order: newSortOrder.newSortOrder,
        };

        this.$store.dispatch("updateTemplateWorkOrderTask", jsConn).then(() => {
          this.$emit("templateTasksChanged");
        });
      }
    },
    deleteTask(task) {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: task.id,
      };

      this.$store.dispatch("deleteTemplateWorkOrderTask", jsConn).then(() => {
        this.$emit("templateTasksChanged");
      });
    },
    deleteLineItem(lineItem) {
      const jsConn = new JSConn();

      jsConn.formParams = {
        id: lineItem.id,
      };

      this.$store
        .dispatch("deleteTemplateWorkOrderTaskLineItem", jsConn)
        .then(() => {
          this.$emit("templateTasksChanged");
        });
    },
  },
};
